import { apiClient } from './client';
import { endpoints } from './endpoints';

export type DwtReason = 'ON_SITE' | 'HOUSEHOLD' | 'ONE_OFF' | 'MARINE';

export interface DwtSettingsDto {
  configured: boolean;
  enabled: boolean;
  environment: 'test' | 'production';
  /** Masked (last 4 only). The full api_code is never returned. */
  api_code_masked: string | null;
  api_code_set: boolean;
  receiver_site_name: string | null;
  receiver_authorisation_number: string | null;
  receiver_address_full: string | null;
  receiver_postcode: string | null;
  carrier_organisation_name: string | null;
  carrier_registration_number: string | null;
  carrier_reason_no_registration: DwtReason | null;
  carrier_means_of_transport: string;
  vendor_credentials: { test: boolean; production: boolean };
  production_calls_allowed: boolean;
}

export interface DwtSettingsInput {
  enabled: boolean;
  environment: 'test' | 'production';
  /** undefined = keep the stored code; '' = clear; UUID = replace. */
  api_code?: string;
  receiver_site_name: string | null;
  receiver_authorisation_number: string | null;
  receiver_address_full: string | null;
  receiver_postcode: string | null;
  carrier_organisation_name: string | null;
  carrier_registration_number: string | null;
  carrier_reason_no_registration: DwtReason | null;
  carrier_means_of_transport: string;
}

export async function fetchDwtSettings(): Promise<DwtSettingsDto> {
  const res = await apiClient.get<DwtSettingsDto>(endpoints.dwtSettings.get);
  return res.data;
}

export async function saveDwtSettings(input: DwtSettingsInput): Promise<DwtSettingsDto> {
  const res = await apiClient.put<DwtSettingsDto, DwtSettingsInput>(
    endpoints.dwtSettings.save,
    input,
  );
  return res.data;
}
